<template>
    <div>
        <Nav></Nav>
       <TermsCom class="m-doc"></TermsCom>
       <Bottom></Bottom>
    </div>
</template>
<script>
import Nav from '../components/mobile/m_nav.vue'
import TermsCom from '../components/termsCom.vue'
import Bottom from '../components/mobile/m_bottom.vue'
export default {
    components: {
        Nav,
        TermsCom,
        Bottom
    }
}
</script>
<style lang='scss'>
@import '@/styles/public';
.m-doc{
    padding: 0 60px;
    padding-bottom: 80px;
    .title{
        text-align: center;
        font-size: 72px;
        font-weight: bold;
        color: $theme-color;
        margin: 80px 0 60px;
    }
    .text{
        font-size: 40px;
        color: #565D75;
    }
    .s-title{
        color: $theme-color;
        font-size: 56px;
        margin: 70px 0 30px;
    }
}
</style>
